/**
 * Recent searches — persisted in localStorage so the SmartSearch dropdown
 * can show a "Recent" rail when empty.
 *
 * Stores at most 8 entries, most-recent-first, deduped case-insensitively.
 * Free of any tracking — purely local-device.
 */
const KEY = "jns:recent-searches:v1";
const MAX = 8;

export function readRecentSearches() {
    if (typeof window === "undefined") return [];
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return [];
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
    } catch {
        return [];
    }
}

export function pushRecentSearch(term) {
    if (typeof window === "undefined") return;
    const t = String(term || "").trim();
    if (t.length < 2) return;
    try {
        const cur = readRecentSearches();
        const dedup = cur.filter((x) => x.toLowerCase() !== t.toLowerCase());
        const next = [t, ...dedup].slice(0, MAX);
        window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        // localStorage unavailable / quota — silently ignore, this is best-effort
    }
}

export function clearRecentSearches() {
    if (typeof window === "undefined") return;
    try { window.localStorage.removeItem(KEY); } catch { /* ignore */ }
}
